import { createSelector } from 'reselect';

const selectPlatformDBAServices = (state: any) => state.platformDBAServices;


export const selectPlatformDBAServicesCurrentItem = createSelector([selectPlatformDBAServices], (platformDBAServices) => platformDBAServices.current);

export const selectPlatformDBAServicesListItems = createSelector([selectPlatformDBAServices], (platformDBAServices) => platformDBAServices.list);

export const selectItemById = (itemId: any) =>
    createSelector(selectPlatformDBAServicesListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectPlatformDBAServicesQueryItems = createSelector([selectPlatformDBAServices], (platformDBAServices) => platformDBAServices.query);

export const selectPlatformDBAServicesCreatedItem = createSelector([selectPlatformDBAServices], (platformDBAServices) => platformDBAServices.create);

export const selectPlatformDBAServicesUpdatedItem = createSelector([selectPlatformDBAServices], (platformDBAServices) => platformDBAServices.update);

export const selectPlatformDBAServicesReadItem = createSelector([selectPlatformDBAServices], (platformDBAServices) => platformDBAServices.read);

export const selectPlatformDBAServicesDeletedItem = createSelector([selectPlatformDBAServices], (platformDBAServices) => platformDBAServices.delete);

export const selectPlatformDBAServicesSearchedItems = createSelector([selectPlatformDBAServices], (platformDBAServices) => platformDBAServices.search);

export const selectPlatformDBAServicesItemsCount = createSelector([selectPlatformDBAServices], (platformDBAServices) => platformDBAServices.count);

export const selectPlatformDBAServicesItemsFilter = createSelector([selectPlatformDBAServices], (platformDBAServices) => platformDBAServices.filter);